import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import SelectDropdown from "../../components/SelectDropdown";
import { Card, Col, Form, Row } from "react-bootstrap";
import GenerateModal from "../../components/GenerateModal";
import InputField from "../../components/InputField";
import { rolesData } from "../../constants/Roles"; 
import useUserManagementCreateViewController from "../../viewControllers/UserManagementViewControllers/UserManagementCreateViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const UserManagementCreate = () => {

  const {
    goBack,
    values,
    touched,
    errors,
    handleChange,
    handleSelectedEmployee,
    handleSubmit,
    showModal,
    setShowModal,
    generatedUsername,
    generatedPassword,
    loading,
    
  } = useUserManagementCreateViewController();

  const text = {
    backBtn: i18n.t('userManagement.userManagementCreate.backBtn'),
    pageHeading: i18n.t('userManagement.userManagementCreate.pageHeading'),
    employeeName: i18n.t('userManagement.userManagementCreate.employeeName'),
    assignRole: i18n.t('userManagement.userManagementCreate.assignRole'),
    employeeEmail: i18n.t('userManagement.userManagementCreate.employeeEmail'),
    submitBtn: i18n.t('userManagement.userManagementCreate.submitBtn'),
  }

  return (
    <>
      {loading ? <Loader /> : (
      <div className="container-fluid mt-5">
        <div className="smb-4">
          <div className="card-header py-3">
          <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
            <h6 className="m-0 font-weight-bold txt-primary">
              {text.pageHeading}
            </h6>
          </div>
          <Card style={{ width: "100%", height: "500px" }}>
            <Form onSubmit={handleSubmit} className="mt-4 mb-4 px-4">
              <Row>
                <Col className="col-lg-6">
                  <Row>
                    <Col className="col-lg-4 mt-3">
                      <p>
                        {text.employeeName} <span style={{ color: "red" }}>*</span>:{" "}
                      </p>
                    </Col>
                    <Col className="col-lg-8">
                      <InputField
                        type="text"
                        value={values?.name}
                        onChange={handleChange("name")}
                        name="name"
                        errors={touched?.name && errors?.name}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col className="col-lg-6">
                  <Row className="mt-5">
                    <Col className="col-lg-4 mt-3">
                      <p>
                        {text.assignRole}<span style={{ color: "red" }}>*</span>:{" "}
                      </p>
                    </Col>
                    <Col className="col-lg-8">
                      <SelectDropdown
                        placeholder="Select"
                        data={rolesData}
                        value={values?.role}
                        onChange={handleSelectedEmployee}
                        errors={touched?.role && errors?.role}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col className="col-lg-6">
                  <Row>
                    <Col className="col-lg-4 mt-3">
                      <p>
                        {text.employeeEmail} <span style={{ color: "red" }}>*</span>:{" "}
                      </p>
                    </Col>
                    <Col className="col-lg-8">
                      <InputField
                        type="text"
                        value={values?.email}
                        onChange={handleChange("email")}
                        name="email"
                        errors={touched?.email && errors?.email}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="d-flex">
                <>
                  <PrimaryButton
                    type="submit"
                    text={text.submitBtn}
                    className="width-auto save-btn "
                  />
                </>
              </div>
              {showModal ? (
                <GenerateModal
                  isCreated={true}
                  setShowModal={setShowModal}
                  showModal={showModal}
                  username={generatedUsername}
                  password={generatedPassword}
                  checkButton={values?.role === "" ? true : false}
                  handleSubmit={handleSubmit}
                />
              ) : null}
            </Form>
          </Card>
        </div>
      </div>
      )}
    </>
  );
};

export default UserManagementCreate;
